import { useEffect, useMemo, useState } from 'react';

export default function useOnScreen(ref: any): boolean {
  const [isIntersecting, setIntersecting] = useState(false);

  const observer = useMemo(() => new IntersectionObserver(([entry]) => setIntersecting(entry.isIntersecting)), []);

  useEffect(() => {
    observer.observe(ref.current);
    // Remove the observer as soon as the component is unmounted
    return () => {
      observer.disconnect();
    };
  }, [observer, ref]);

  return isIntersecting;
}

/**
   * Usage
   * const DummyComponent = () => {

  const ref = useRef()
  const isVisible = useOnScreen(ref)

  return <div ref={ref}>{isVisible && `Yep, I'm on screen`}</div>
}
   *
   */
